import React from "react";
import Header from "../../components/header/index";
import InnerHeader from "../../components/comment/innerHeader/innerHeader";
import DocumentUploadContent from "./uploadcontent/documentuploadcontent";

import Footer from "../../components/footer";

const index = () => {
  return (
    <div className="main">
      <Header />
      <InnerHeader title="Verification Document Upload " />
      <DocumentUploadContent />
      <Footer />
    </div>
  );
};

export default index;
